import { of } from 'rxjs';
import { BaseODataService, ODataQueryParams } from 'src/app/shared/services/base-odata.service';
import { Image } from 'src/app/people/models/image';
import { Injectable } from '@angular/core';
import { PeopleFilterFields } from 'src/app/people/models/peopleFilterFields';
import { ApiVersions } from 'src/app/shared/services/api-version';
import { People } from 'src/app/people/models/people.model';
import { map } from 'rxjs/operators';
import { PEOPLE_FILTER_MODELS } from 'src/app/shared/components/odata-filter/models/system-filter-models';
import { PeopleFilterResult } from 'src/app/people/models/peopleFilterResult.model';
import { AutoCompletePersonModel } from '../../models/autoCompletePerson';

@Injectable({
  providedIn: 'root'
})
export class PersonAutocompleteService extends BaseODataService {
  constructor() {
    super();
    this._baseUrl = 'people';
    this._searchTextModel = PEOPLE_FILTER_MODELS.SearchFilterModel;
    this._filterResult = new PeopleFilterResult();
  }
  search(value: string) {
    if (!value || value.length < 2) return of([]);
    this.searchText = value;
    let params: ODataQueryParams = {
      select: [
        PeopleFilterFields.id,
        PeopleFilterFields.fullName,
        PeopleFilterFields.email,
        PeopleFilterFields.tags,
        PeopleFilterFields.updatedOn,
        PeopleFilterFields.status,
        PeopleFilterFields.imageId
      ],
      filter: this.buildFilter([]),
      count: false,
      expand: [PeopleFilterFields.tags],
      orderBy: [PeopleFilterFields.fullName]
    };
    return this.getODataResult(this.filterUrl, params, ApiVersions.v1_0).pipe(
      map((response) => {
        if (response && response.value) {
          return response.value.map((v: People) => {
            if (v.imageId) {
              v.image = new Image(v.imageId);
            }
            return AutoCompletePersonModel.parse(v);
          });
        } else {
          return [];
        }
      })
    );
  }
}
